<info-page-header [label]="title"></info-page-header>
<div class="info-screen">
  <section class="info-page">
    <!-- Video (si se proporciona videoSrc) -->
    <div class="info-page__media-wrapper" *ngIf="videoSrc">
      <iframe
        class="info-page__video"
        [src]="videoSrc"
        title="Video"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen>
      </iframe>
    </div>

    <!-- Imagen (si se proporciona imageSrc y no hay video) -->
    <div class="info-page__media-wrapper" *ngIf="imageSrc && !videoSrc">
      <img
        class="info-page__image"
        [src]="imageSrc"
        [alt]="imageAlt || 'Imagen informativa'"
      />
    </div>

    <section class="info-page__content">
      <h2 class="info-page__subtitle" *ngIf="subtitle">
        {{ subtitle }}
      </h2>
      <h3 class="info-page__prefix" *ngIf="prefix">
        {{ prefix }}
      </h3>
      <div class="info-page__text">
        <ng-content></ng-content>
      </div>
    </section>
  </section>
</div>
